<script>
  // The status pill on a scenario card.
  //
  // This is where status colour lives now. It used to be the background of the
  // entire page section -- bg-blue-400 behind every Ready card, bg-error behind
  // every Error card -- a screenful of one saturated colour to say something
  // the tab strip and the section heading were already saying.
  import { statusMeta } from "../../lib/status.js";

  export let status;
  /** Shows a spinner in the pill. Used by the Busy card. */
  export let live = false;
  /** Overrides the default label, e.g. the solver's own phase text. */
  export let label = null;

  $: meta = statusMeta(status);
</script>

<span
  class="inline-flex items-center gap-1.5 rounded-badge px-2 py-0.5 text-xs font-medium whitespace-nowrap {meta.badge}"
>
  {#if live}
    <i class="fas fa-circle-notch fa-spin text-[0.6rem]" aria-hidden="true"></i>
  {/if}
  {label ?? meta.label}
</span>
